import * as Sentry from "@sentry/react";

import { appCommonConfig } from "@/config/config";
import { FrontEndTelemetryDataInputDto } from "@/core/api/generated/v1";

import { SentryTagKey } from "../constants/sentry";
import { SessionStorageKey } from "../constants/sessionStorage";
import { EncodingHelper } from "./encoding";
import { IdHelper } from "./id";
import { SessionStorageHelper } from "./storage/sessionStorage";

interface ITelemetryDataInSessionStorage {
  correlationId?: Nil<string>;
}

/** Helper for telemetry. E.g. Sentry, OpenTelemetry, etc. */
export class TelemetryHelper {
  /** Generates custom correlation ID to be used in telemetry. */
  private static generateCorrelationId(): string {
    return IdHelper.newUuid4();
  }

  /** Returns current correlation ID or generates new one. */
  public static getOrCreateCorrelationId(): string {
    let telemetryData = SessionStorageHelper.getTypedJsonItem<ITelemetryDataInSessionStorage>(
      SessionStorageKey.telemetryData,
    );
    if (!telemetryData?.correlationId) {
      telemetryData ||= {};
      telemetryData.correlationId ||= this.generateCorrelationId();
      SessionStorageHelper.setJsonItem(SessionStorageKey.telemetryData, telemetryData);
    }

    return telemetryData.correlationId;
  }

  public static setSentryTagsOnAppInit(): void {
    const tags = {
      [SentryTagKey.appVersion]: appCommonConfig.version,
      [SentryTagKey.correlationId]: this.getOrCreateCorrelationId(),
    };
    console.log("Custom Sentry tags:", tags);
    Sentry.setTags(tags);
  }

  public static getTelemetryDataInput(): FrontEndTelemetryDataInputDto {
    return {
      correlationId: this.getOrCreateCorrelationId(),
      pageUrl: window.location.href,
      // appVersion: appCommonConfig.version,
      // tenantIdentifier: tenantService.resolveTenant()?.identifier,
    };
  }

  public static getTelemetryDataInputEncodedForHttpHeader(): string {
    const data = this.getTelemetryDataInput();
    const json = JSON.stringify(data);
    return EncodingHelper.stringToBase64(json);
  }
}
